import React from 'react';

const videos = [
  { year: '2026', id: 'EMDb5nQBDRk' },
  { year: '2025', id: 'Mi_OqOqyb2s' },
  { year: '2024', id: 'Cwm7hxiA3RA' },
  { year: '2023', id: 'CyfHRgQdo-4' },
  { year: '2022', id: 'Nd4gqjTsQ9c' },
  { year: '2021', id: 'lze-kF4Gk5Q' },
  { year: '2018', id: '-vo9mSdQ5Y4' },
  { year: '2017', id: '7Of4N0Zy7rE' },
];

const SummerSchoolVideoArchive = () => (
  <section className="summer-school-videos" aria-labelledby="summer-school-videos-title">
    <div className="summer-school-videos-inner">
      <header className="summer-school-videos-header">
        <p className="summer-school-eyebrow">WATCH THE JOURNEY</p>
        <h2 id="summer-school-videos-title">Space Summer School Highlights</h2>
        <div className="summer-school-title-line" aria-hidden="true" />
      </header>

      <div className="summer-school-video-grid">
        {videos.map(({ year, id }) => (
          <article className="summer-school-video-card" key={year}>
            <div className="summer-school-video-frame">
              <iframe
                src={`https://www.youtube-nocookie.com/embed/${id}`}
                title={`Space Summer School ${year} highlights`}
                loading="lazy"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              />
            </div>
            <h3>Space Summer School {year}</h3>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default SummerSchoolVideoArchive;
